module.exports = __webpack_public_path__ + "static/media/white-shelf.1f933577.png";